<script>
import Masonry from "masonry-layout";
import { register } from "swiper/element/bundle";
import "swiper/css";

register();

export default {
  props: {
    className: {
      type: String,
      default: "container-xl",
    },
    headline: {
      type: String,
      default: "Wir bleiben mit unseren Kunden im Austausch",
    },
    text: {
      type: String,
      default:
          "Unser System wird stetig weiter entwickelt, um langfristig qualitativ zu bleiben. Der Austausch mit unseren Kunden ist dabei unerlässlich, um up to date zu bleiben.",
    },
    link: {
      type: Object,
      default: () => ({
        text: "Jetzt Kontakt aufnehmen",
        url: "mailto:akademie@de.tuv.com",
      }),
    },
    slidesData: {
      type: Array,
      default: () => [
        {
          name: "Nuria Pelayo",
          business: "Treequote",
          avatar: "https://i.pravatar.cc/150",
          text: '"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua."',
        },
        {
          name: "Nuria Pelayo",
          business: "Treequote",
          avatar: "https://i.pravatar.cc/150",
          text: '"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet."',
        },
        {
          name: "Nuria Pelayo",
          business: "Treequote",
          avatar: "https://i.pravatar.cc/150",
          text: '"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore und dolore magna aliquyam erat, sed diam voluptua"',
        },
        {
          name: "Nuria Pelayo",
          business: "Treequote",
          avatar: "https://i.pravatar.cc/150",
          text: '"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore und dolore magna aliquyam erat, sed diam voluptua"',
        },
      ],
    },
  },
  setup() {
    const isMobile = ref(false);
    const masonryInstance = ref(null);
    const breakpointLg = ref(992);

    const getCssCustomProperty = (property) => {
      const value = window
          .getComputedStyle(document.documentElement)
          .getPropertyValue(property)
          .trim();
      return value || null;
    };

    const addSpacingForSecondColumn = () => {
      const grid = document.querySelector(".testimonials-grid");
      if (grid) {
        const items = Array.from(grid.children);

        if (items.length > 1) {
          const secondColumnFirst = items[1];
          secondColumnFirst.classList.add("second-column-first");
        }
      }
    };

    const checkViewport = () => {
      const lgBreakpoint =
          parseInt(getCssCustomProperty("--breakpoint-lg")) || breakpointLg.value;
      const wasMobile = isMobile.value;
      isMobile.value = window.innerWidth < lgBreakpoint;

      if (wasMobile && !isMobile.value) {
        destroyMasonry();
        nextTick(() => {
          initMasonry();
          addSpacingForSecondColumn();
        });
      } else if (!wasMobile && isMobile.value) {
        destroyMasonry();
      } else {
        nextTick(() => {
          addSpacingForSecondColumn();
        });
      }
    };

    const initMasonry = () => {
      const grid = document.querySelector(".testimonials-grid");
      if (grid) {
        masonryInstance.value = new Masonry(grid, {
          itemSelector: ".testimonials-quote-card",
          columnWidth: ".testimonials-quote-card",
          percentPosition: true,
          gutter: 30,
        });

        nextTick(() => {
          addSpacingForSecondColumn();
        });
      }
    };

    const destroyMasonry = () => {
      if (masonryInstance.value) {
        masonryInstance.value.destroy();
        masonryInstance.value = null;
      }
    };

    onMounted(() => {
      breakpointLg.value =
          parseInt(getCssCustomProperty("--breakpoint-lg")) || breakpointLg.value;
      checkViewport();
      window.addEventListener("resize", checkViewport);

      if (!isMobile.value) {
        nextTick(() => {
          initMasonry();
          addSpacingForSecondColumn();
        });
      }
    });

    onUnmounted(() => {
      window.removeEventListener("resize", checkViewport);
      destroyMasonry();
    });

    return {
      isMobile,
    };
  }
};
</script>
<template>
  <div :class="className" class="testimonals-widget">
    <div class="row testimonials-content">
      <div class="col-lg-5 text-center text-lg-left">
        <i class="trainer" aria-hidden="true"></i>
        <h2 class="display-2">
          {{ headline }}
        </h2>

        <div class="info-textbox">
          <p>{{ text }}</p>
          <a
              :href="link.url"
              class="btn btn-primary text-uppercase w-100 w-md-75 w-xl-100 text-wrap"
              aria-label="Nehmen Sie jetzt Kontakt mit uns auf"
          >
            {{ link.text }}
          </a>
        </div>
      </div>

      <div class="col-lg-7">
        <!-- Swiper für Mobile -->
        <swiper-container
            v-if="isMobile"
            loop="true"
            slides-per-view="1.25"
            class="testimonials-swiper"
            aria-roledescription="carousel"
            aria-label="Kundenmeinungen"
        >
          <swiper-slide
              v-for="(slide, index) in slidesData"
              :key="index"
              tabindex="0"
              role="group"
              :aria-label="'Slide ' + (index + 1) + ' von ' + slidesData.length"
          >
            <article class="testimonials-quote-card" role="region">
              <blockquote class="quote">
                <p>{{ slide.text }}</p>
              </blockquote>
              <footer class="person" aria-label="Kunde">
                <img
                    class="avatar"
                    :src="slide.avatar"
                    :alt="'Profilbild von ' + slide.name"
                />
                <p class="person-info">
                  <strong>{{ slide.name }}</strong>
                  <small>{{ slide.business }}</small>
                </p>
              </footer>
            </article>
          </swiper-slide>
        </swiper-container>

        <!-- Masonry für Desktop -->
        <div v-else class="testimonials-grid" role="list">
          <article
              v-for="(slide, index) in slidesData"
              :key="index"
              class="testimonials-quote-card"
              role="listitem"
          >
            <blockquote class="quote">
              <p>{{ slide.text }}</p>
            </blockquote>
            <footer class="person" aria-label="Kunde">
              <img
                  class="avatar"
                  :src="slide.avatar"
                  :alt="'Profilbild von ' + slide.name"
              />
              <p class="person-info">
                <strong>{{ slide.name }}</strong>
                <small>{{ slide.business }}</small>
              </p>
            </footer>
          </article>
        </div>
      </div>
    </div>

    <div class="testimonials-bg" aria-hidden="true"></div>
  </div>
</template>